import { Accordion, createAccordion } from '@vfde-brix/ws10/accordion';
import { HtmlId } from '../enum';
import { trackAccordion } from '../tracking/tracking';
import { TrackingUIType } from '../tracking/enum';
import { createComponentById } from '@vfde-brix/ws10/core';

/**
 * Create Brix Accordion component.
 * @param {HtmlId} id - ID of the accordion element.
 * @param {TrackingUIType} trackType - type of the tracking data to be sent
 * @returns {Accordion | null} component or null if element with given id is not found
 */
export const mountAccordion = (id: HtmlId, trackType: TrackingUIType) =>
    createComponentById(createAccordion, id, {
        onToggle: (props) => {
            if (props.optOpen) {
                trackAccordion(props.stdHeadline, trackType);
            }
        },
    });

/**
 * Closes all items inside an accordion
 * @param {Accordion} comp - accordion to update
 */
export const closeAccordion = (comp: Accordion) => {
    const { items } = comp.getProperties();

    for (const item of items) {
        item.optOpen = false;
    }

    comp.update({ items });
};
